import hurmycketkostarminel from "../media/hurmycketkostarminelE.png";
import webshop from "../media/bokshopE.png";
import restaurant from "../media/lemonRestaurantE.png";
import quiz from "../media/dogBreedsQuizE.png";
import catena from "../media/catena.png";
import sysav from "../media/sysav.png";
import rescue from "../media/rescue.png";
import subaru from "../media/subaru.png";
import lhb from "../media/lhb.png";
import energismart from "../media/oresundskraft_app.png";

export const projects = [
  {
    title: "Energismart med Öresundskraft",
    description:
      "I ett team på fem utvecklare så byggde vi en egen energiapp åt Öresundskraft. I appen kan man se sin elkonsumption och styra olika smarta enheter i hemmet. Vi arbetade i React Native med Typescript och använde oss av Firebase för att integrera analytiska vertyg.",
    image: energismart,
    tags: [
      "React Native",
      "Expo",
      "Typescript",
      "Firebase",
    ],
    source: "",
    liveVersion: "https://play.google.com/store/search?q=energismart+med+%C3%B6resundskraft&c=apps",
    id: 9,
  },
  {
    title: "Första klientprojekt: LHB-förbundet",
    description:
      "LHB-föreningen beställde en ny hemsida. Direktiven var: Enkel stil, läslig och lätt för redaktören att använda. Appen är byggd på .NET platformen med Umbraco som CMS. Styling delvis i bootstrap, men även ren css. Hosting sker i Azure med deras cloudlösningar som Web App, Blob Storage och Azure SQL.",
    image: lhb,
    tags: [
      ".NET Core 8",
      "Azure cloud",
      "Bootstrap",
      "Umbraco CMS",
      "Responsive",
    ],
    source: "https://github.com/Kwixie/LHB-website-V2",
    liveVersion: "https://lhbv2.azurewebsites.net/",
    id: 8,
  },
  {
    title: "Ny hemsida åt Sysav",
    description:
      "Vi var ett team på tre utvecklare hos Blinka Blå som gjorde frontend till sidan. Jag har byggt många av redaktörsblocken med bilder och text, herosektion till flera sidor, footer och merparten under 'Min sophämtning', 'Press och media' och kampanjsidor. Fick komma in ordentligt i Umbraco som CMS, men även Tailwind som css ramverk. Att göra sidan tillgänglighetsanpassad (WCAG) var också prioriterat i utvecklandet.",
    image: sysav,
    tags: [
      ".NET Core 7",
      "Typescript",
      "Tailwind",
      "rest-API",
      "Umbraco CMS",
      "WCAG",
    ],
    source: "",
    liveVersion: "https://www.sysav.se/",
    id: 0,
  },
  {
    title: "Rest-API webbsida med kalkylator",
    description:
      "En webbsida som visar hur mycket ström olika apparater i hemmet drar och vad det kostar just nu utifrån det aktuella spotpriset. Sidan har även en sparkalkylator. Design och idé är egen. Fick lära mig en hel del om att bygga i React, porjektstruktur, API-kopplingar och responsiv design.",
    image: hurmycketkostarminel,
    tags: ["JavaScript", "React", "Sass", "rest-API", "Responsive"],
    source: "https://github.com/Kwixie/hur-mycket-kostar-min-el",
    liveVersion: "https://hurmycketkostarminel.se/",
    id: 1,
  },
  {
    title: "Bransmansquiz för Rescue Tech",
    description:
      "Hos Blinka Blå fick jag bygga ett quiz åt Rescue Tech för att locka in fler besökare till deras hemsida. Jag har gjort så gott som all styling, både på startsidan och profilsidorna. Jag fick även skriva delar av logiken för själva quizet.",
    image: rescue,
    tags: [".NET Core 7", "SASS", "Javascript", "Umbraco CMS"],
    source: "",
    liveVersion:
      "https://www.rescueintellitech.com/en-us/what-type-of-firefighter-are-you/",
    id: 2,
  },
  {
    title: "Webbshop med full CRUD",
    description:
      "En online webshopp för klassiska böcker. Projektet var inspirerat av, och använder startkod från Crwn-clothing-v2 av ZhangMYihua, men boktemat och att man som inloggad användare kan gilla och spara favoriter är eget.",
    image: webshop,
    tags: ["React", "JavaScript", "Redux", "Firebase", "Responsive"],
    source: "https://github.com/Kwixie/book-store-webshop",
    liveVersion: "https://golden-moonbeam-d30684.netlify.app",
    id: 3,
  },
  {
    title: "Catena uppdaterad frontend",
    description:
      "Hos Blinka Blå fick jag i uppdrag att uppdatera stylingen på hela hemsidan till Catena.se till en ny mer modern look. Jag fick också bygga några nya komponenter i Umbraco / .NET Core",
    image: catena,
    tags: ["JavaScript", "SASS", ".NET Core", "Umbraco CMS"],
    source: "",
    liveVersion: "https://www.catena.se/",
    id: 4,
  },
  {
    title: "Uppgradering av Subaru",
    description:
      "Hos Blinka Blå fick jag ansvara över att uppgradera Subarus hemsida från Umbraco 12 till Umbraco 13 och göra ny deploy av sidan. Jag fick också göra en del uppdateringar i stylingen.",
    image: subaru,
    tags: ["JavaScript", "SASS", ".NET Core 8", "Umbraco CMS"],
    source: "",
    liveVersion: "https://www.subaru.se/",
    id: 5,
  },
  {
    title: "Restauranghemsida med bokningsformulär",
    description:
      "Under 2022 - 2023 läste jag Metas frontend-utbildning på lärarplatformen Coursera, som gick igenom allt ifrån grunderna i webbutveckling, fördjupning i Css, Javascript och React och även hade en modul om grundläggande programmeringskoncept (algorimter, data-strukturer, arkitektur). Denna restaurangsida med bokningsformulär var ett av slutprojekten.",
    image: restaurant,
    tags: ["React", "JavaScript", "Material UI", "Responsive"],
    source: "https://github.com/Kwixie/little-lemon-website",
    liveVersion: "https://euphonious-sherbet-c8d61e.netlify.app/",
    id: 6,
  },
  {
    title: "Quiz App",
    description:
      "Ett av mina första programmeringsprojekt. En quizapp om hundraser byggd i vanilla javascript.",
    image: quiz,
    tags: ["JavaScript", "CSS", "rest-API", "Responsive"],
    source: "https://github.com/Kwixie/Dog-Breeds-Quiz",
    liveVersion: "https://kwixie.github.io/Dog-Breeds-Quiz/index.html",
    id: 7,
  },
  // {
  //   title: "Kommande projekt: Bildgalleri med quiz i Next.js",
  //   description:
  //     "En sida där man kan söka på en stad och få generade bilder från Pexels. Man kommer också kunna göra quiz som går ut på att gissa vilken stad som visas på bilderna. Projektet byggs i Next.js med React och Tailwind och kodas i TypeScript.",
  //   image: citiesgallery,
  //   tags: ["Next.js", "React", "TypeScript", "Tailwind"],
  //   source: "",
  //   liveVersion: "",
  //   id: 5,
  // },
];
